import React from 'react';

function About() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Hero Section */}
      <div className="relative overflow-hidden py-20" style={{background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'}}>
        <div className="absolute inset-0" style={{backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'}}></div>
        <div className="container relative">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 backdrop-blur-sm rounded-2xl mb-6 mx-auto" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '80px', height: '80px', margin: '0 auto 1.5rem', background: 'rgba(255,255,255,0.1)'}}>
                <i className="fas fa-tools text-white text-4xl"></i>
              </div>
              <h1 className="display-4 fw-bold text-white mb-4">
                Herramientas Tayrun
              </h1>
              <p className="lead mb-0" style={{fontSize: '1.25rem', color: '#94a3b8'}}>
                Tu tienda de confianza en herramientas profesionales y equipamiento de calidad
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{marginTop: '-60px', position: 'relative', zIndex: 10}}>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg" style={{borderRadius: '1.5rem', overflow: 'hidden'}}>
              <div className="card-body p-5">

                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="text-center p-4 h-100" style={{background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '1rem', transition: 'transform 0.3s ease, box-shadow 0.3s ease'}}>
                      <div className="mb-3" style={{width: '70px', height: '70px', background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', boxShadow: '0 4px 14px rgba(30, 41, 59, 0.3)'}}>
                        <i className="fas fa-bullseye fa-2x text-white"></i>
                      </div>
                      <h4 className="fw-bold mb-3" style={{color: '#1e293b'}}>Nuestra Misión</h4>
                      <p className="text-muted mb-0">
                        Proveer herramientas profesionales de alta calidad a precios competitivos, garantizando la satisfacción de cada cliente.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="text-center p-4 h-100" style={{background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '1rem', transition: 'transform 0.3s ease, box-shadow 0.3s ease'}}>
                      <div className="mb-3" style={{width: '70px', height: '70px', background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', boxShadow: '0 4px 14px rgba(71, 85, 105, 0.3)'}}>
                        <i className="fas fa-heart fa-2x text-white"></i>
                      </div>
                      <h4 className="fw-bold mb-3" style={{color: '#1e293b'}}>Nuestros Valores</h4>
                      <p className="text-muted mb-0">
                        Honestidad, calidad, compromiso y atención personalizada en cada interacción con nuestros clientes.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="text-center p-4 h-100" style={{background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '1rem', transition: 'transform 0.3s ease, box-shadow 0.3s ease'}}>
                      <div className="mb-3" style={{width: '70px', height: '70px', background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', boxShadow: '0 4px 14px rgba(100, 116, 139, 0.3)'}}>
                        <i className="fas fa-history fa-2x text-white"></i>
                      </div>
                      <h4 className="fw-bold mb-3" style={{color: '#1e293b'}}>Nuestra Historia</h4>
                      <p className="text-muted mb-0">
                        Desde nuestros inicios, hemos crecido junto a nuestros clientes, construyendo una reputación de excelencia y confianza.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="text-center p-4 h-100" style={{background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '1rem', transition: 'transform 0.3s ease, box-shadow 0.3s ease'}}>
                      <div className="mb-3" style={{width: '70px', height: '70px', background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', boxShadow: '0 4px 14px rgba(71, 85, 105, 0.3)'}}>
                        <i className="fas fa-users fa-2x text-white"></i>
                      </div>
                      <h4 className="fw-bold mb-3" style={{color: '#1e293b'}}>Nuestro Equipo</h4>
                      <p className="text-muted mb-0">
                        Profesionales apasionados por las herramientas, listos para asesorarte y ayudarte a encontrar lo que necesitas.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="my-5" style={{height: '1px', background: 'linear-gradient(90deg, transparent, #e2e8f0, transparent)'}}></div>

                <div className="text-center">
                  <h3 className="fw-bold mb-2" style={{color: '#1e293b'}}>¿Por qué elegir Herramientas Tayrun?</h3>
                  <p className="text-muted mb-5">Somos tu mejor opción en herramientas y equipamiento</p>
                  <div className="row g-4">
                    <div className="col-md-4">
                      <div className="p-4" style={{background: '#f8fafc', borderRadius: '1rem', height: '100%'}}>
                        <div style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem'}}>
                          <i className="fas fa-shipping-fast text-white"></i>
                        </div>
                        <h5 className="fw-bold" style={{color: '#1e293b'}}>Entrega Rápida</h5>
                        <p className="text-muted small mb-0">
                          Entregamos en todo Paraguay con rapidez y seguridad garantizada
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="p-4" style={{background: '#f8fafc', borderRadius: '1rem', height: '100%'}}>
                        <div style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem'}}>
                          <i className="fas fa-shield-alt text-white"></i>
                        </div>
                        <h5 className="fw-bold" style={{color: '#1e293b'}}>Garantía de Calidad</h5>
                        <p className="text-muted small mb-0">
                          Productos originales con garantía y respaldo oficial
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="p-4" style={{background: '#f8fafc', borderRadius: '1rem', height: '100%'}}>
                        <div style={{width: '50px', height: '50px', background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem'}}>
                          <i className="fab fa-whatsapp text-white"></i>
                        </div>
                        <h5 className="fw-bold" style={{color: '#1e293b'}}>Atención Personalizada</h5>
                        <p className="text-muted small mb-0">
                          Asesoría experta vía WhatsApp cuando la necesites
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-5">
                  <a href="/products" className="btn btn-lg me-3" style={{background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)', color: 'white', border: 'none', borderRadius: '0.75rem', padding: '0.875rem 2rem', boxShadow: '0 4px 14px rgba(30, 41, 59, 0.3)', transition: 'transform 0.2s ease, box-shadow 0.2s ease'}}>
                    <i className="fas fa-tools me-2"></i>
                    Ver Productos
                  </a>
                  <a href="/contact" className="btn btn-lg" style={{background: 'transparent', color: '#334155', border: '2px solid #334155', borderRadius: '0.75rem', padding: '0.875rem 2rem', transition: 'all 0.2s ease'}}>
                    <i className="fab fa-whatsapp me-2"></i>
                    Contactanos
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
